export default __webpack_public_path__ + "static/media/logo.1aa6c6b5.png";